/**
 * 去除数组中重复的对象
 * @param arr 数组
 * @param getKey 回调，把对象给出去，返回一个区分对象的Key
 * @returns {*[]}
 */
export function uniqueArray(arr, getKey){
  const map = {};
  arr.forEach((e, index) => {
    let key = getKey(e);
    if(!map[key]){
      map[key] = index;
    }
  })
  return Object.keys(map).map(key => arr[map[key]]);
}
export function uniqueFloor(arr, fn){
  const map = {max: 0};
  arr.forEach((e) => {
    let {key, value} = fn(e);
    if(!map[key]){
      map[key] = new Set();
    }
    map[key].add(value);
    if(map.max < value){
      map.max = value;
    }
  })
  return map;
}